<!-- API Navigation (groupedNavItems) -->
<ng-container *ngIf="contentType === 'api'">
    <div #navAccordion="ngbAccordion" ngbAccordion [closeOthers]="true">

        <!-- CATEGORY LEVEL -->
        <ng-container *ngFor="let category of groupedNavItems; trackBy: trackByCategory">
            <div ngbAccordionItem [collapsed]="!isCategoryExpanded(category.categoryId)">
                <h2 ngbAccordionHeader>
                    <button class="sidebar-nav sidebar-title" ngbAccordionButton>
                        {{ category.categoryName }}
                    </button>
                </h2>
                <div ngbAccordionCollapse>
                    <div ngbAccordionBody>
                        <ng-template>
                            <!-- GROUP LEVEL -->
                            <ng-container *ngIf="category.groups?.length">
                                <div ngbAccordion>
                                    <ng-container *ngFor="let navGroup of category.groups; trackBy: trackByGroup">
                                        <div ngbAccordionItem [collapsed]="!isGroupExpanded(navGroup.groupCode)">
                                            <h2 ngbAccordionHeader>
                                                <button class="sidebar-nav sidebar-subtitle" ngbAccordionButton
                                                    (click)="onGroupExpand()">
                                                    {{ navGroup.group }}
                                                </button>
                                            </h2>
                                            <div ngbAccordionCollapse>
                                                <div ngbAccordionBody>
                                                    <ng-template>
                                                        <!-- ENDPOINT LEVEL -->
                                                        <ul class="endpoint-nav-list" *ngIf="navGroup.endpoints?.length">
                                                            <ng-container
                                                                *ngFor="let endpoint of navGroup.endpoints; trackBy: trackByEndpoint">
                                                                <li [title]="endpoint.uri">
                                                                    <a routerLink="/e/{{endpoint.slug}}"
                                                                        [ngClass]="['endpoint-link', activeItem === endpoint.slug ? 'active' : '']">
                                                                        <div class="endpoint-top">
                                                                            <p class="endpoint-name"
                                                                                id="{{endpoint.slug}}">
                                                                                {{ endpoint.uri }}
                                                                            </p>
                                                                            <span
                                                                                class="request-method {{ endpoint.method | lowercase }}">
                                                                                {{ endpoint.method }}
                                                                            </span>
                                                                        </div>
                                                                        <p class="endpoint-desc">{{ endpoint.label }}</p>
                                                                    </a>
                                                                </li>
                                                            </ng-container>
                                                        </ul>
                                                    </ng-template>
                                                </div>
                                            </div>
                                        </div>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </ng-template>
                    </div>
                </div>
            </div>
        </ng-container>

    </div>
</ng-container>

<!-- Docs Navigation (docsNavItems) -->
<ng-container *ngIf="contentType === 'docs'">
    <div #navAccordion="ngbAccordion" ngbAccordion [closeOthers]="true">

        <ng-container *ngFor="let item of docsNavItems; trackBy: trackByDocItem">

            <!-- Category with children -->
            <ng-container *ngIf="item.type === 'category' && item.children && item.children.length > 0">
                <div ngbAccordionItem [collapsed]="!isDocCategoryExpanded(item.slug)">
                    <h2 ngbAccordionHeader>
                        <button class="sidebar-nav sidebar-title" ngbAccordionButton>
                            {{ item.name }}
                        </button>
                    </h2>
                    <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                            <ng-template>
                                <ul class="docs-nav-list">
                                    <ng-container *ngFor="let child of item.children; trackBy: trackByDocChild">
                                        <li>
                                            <a routerLink="/docs/{{child.slug}}"
                                                [ngClass]="['doc-link', isDocActive(child.slug) ? 'active' : '']">
                                                {{ child.title }}
                                            </a>
                                        </li>
                                    </ng-container>
                                </ul>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- Empty category (no children) - must have full accordion structure -->
            <ng-container *ngIf="item.type === 'category' && (!item.children || item.children.length === 0)">
                <div ngbAccordionItem [collapsed]="true" [disabled]="true">
                    <h2 ngbAccordionHeader>
                        <button class="sidebar-nav sidebar-title sidebar-title-empty" ngbAccordionButton>
                            {{ item.name }}
                        </button>
                    </h2>
                    <div ngbAccordionCollapse>
                        <div ngbAccordionBody>
                            <ng-template>
                                <p class="empty-category-message">No documents available</p>
                            </ng-template>
                        </div>
                    </div>
                </div>
            </ng-container>

            <!-- Standalone doc (no category wrapper) - rendered outside accordion -->
            <ng-container *ngIf="item.type === 'doc' && item.slug">
                <div class="standalone-doc-item">
                    <a routerLink="/docs/{{item.slug}}"
                        [ngClass]="['sidebar-nav sidebar-title doc-standalone-link', isDocActive(item.slug) ? 'active' : '']">
                        {{ item.name }}
                    </a>
                </div>
            </ng-container>

        </ng-container>

    </div>
</ng-container>